import React from 'react';
import { NavLink } from 'react-router-dom';
import Header2 from '../Common/Header2';
import Footer from '../Common/Footer';
import Banner from '../Elements/Banner';
import { projects } from '../Elements/ProjectsData';

const filters = [
    { label: "Ongoing", filter: ".col-one" },
    { label: "Completed", filter: ".col-two" },
    // { label: "Safety Standards", filter: ".col-three" }
];

var bnrimg = require('./../../images/banner/8.jpg');

const Projects = () => {
    
    return (
        <>
            <Header2 />
            <div className="page-content">
                <Banner title="Projects" pagename="Project with Masonry With 3 Columns" description="" bgimage={bnrimg}/>
                
                {/* SECTION CONTENT START */}
                <div className="section-full p-tb80 bg-white inner-page-padding">
                    {/* GALLERY CONTENT START */}
                    <div className="container">
                        {/* Filter Nav START */}
                        <div className="filter-wrap p-b30 text-center">
                            <ul className="filter-navigation masonry-filter clearfix">
                                <li className="active"><NavLink to={"#"} className="btn from-top" data-filter="*" data-hover="All">All</NavLink></li>
                                {filters.map((item, index) => (
                                    <li key={index}><NavLink to={"#"} className="btn from-top" data-filter={item.filter} >{item.label}</NavLink></li>
                                ))}
                            </ul>
                        </div>
                        {/* Filter Nav END */}
                        {/* GALLERY CONTENT START */}
                        <ul className="masonry-outer mfp-gallery work-grid row clearfix list-unstyled">
                            {projects.map((item, index) => (
                                <div key={index} className={`${item.filter} masonry-item col-lg-4  col-md-4 col-sm-6 m-b30`}>
                                    <div className="project-mas hover-shadow">
                                        <div className="image-effect-one">
                                            <img src={item.image1} alt="" />
                                            <div className="figcaption">
                                                <a className="mfp-link" href={item.image1}>
                                                    <i className="fa fa-arrows-alt" />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="project-info p-a20 bg-gray">
                                            <h4 className="sx-tilte m-tb0"><NavLink to={`/${item.title.toLowerCase().replace(/\s+/g, '-')}`}>{item.title}</NavLink></h4>
                                            {/* to={`/${item.title.toLowerCase().replace(/\s+/g, '-')}`} */}
                                            <p>{item.description}</p>
                                            <NavLink to={"#"}><i className="link-plus bg-primary" /></NavLink>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </ul>
                    </div>
                    {/* GALLERY CONTENT END */}
                </div>
                {/* SECTION CONTENT END  */}
            </div>
            <Footer />
        </>
    );
    };

export default Projects;